<div class="modal-content m-0">
  <div class="modal-header">
    <p class="modal-title">
      {{ 'sample.details.title' | translate }}
    </p>
    <i
      class="fa-light fa-xmark ms-auto cursor-pointer"
      (click)="dialogRef.close()"
    ></i>
  </div>
  <div class="modal-body">
    @if (sample$ | async; as sample) {
      <div class="row">
        <div
          [ngClass]="{
            'col-12 col-md-6': sample.shippingInformation.documentId,
            'col-12':
              !sample.shippingInformation.documentId ||
              !(documentPreviewPermission$ | async),
          }"
        >
          <div class="d-flex justify-content-between align-items-end mb-1">
            <p class="caption mb-1">
              {{ 'common.titleBaseInformation' | translate }}
            </p>
            <div class="text-end col-3">
              <button
                class="icon-btn mb-1 me-2"
                ngbTooltip="Kit details"
                triggers="hover"
                placement="left"
                type="submit"
                [class.icon-btn-sm]="!coreUtilsService.tabletMode()"
                [class.icon-btn-lg]="coreUtilsService.tabletMode()"
                (click)="kitsUtils.openKitDetails(sample.kitId)"
              >
                <i class="fa-light fa-kit-medical fa-fw"></i>
              </button>
              <button
                class="icon-btn mb-1 me-2"
                ngbTooltip="Follow ups"
                triggers="hover"
                placement="left"
                *appRequirePermission="'followUps'"
                type="submit"
                [class.icon-btn-sm]="!coreUtilsService.tabletMode()"
                [class.icon-btn-lg]="coreUtilsService.tabletMode()"
                (click)="
                  followUpsUtils.openFollowUpsListDialog(sample.followUpIds)
                "
              >
                <i class="fa-light fa-square-exclamation fa-fw"></i>
              </button>
              <button
                class="icon-btn mb-1 me-2"
                ngbTooltip="Add follow up"
                triggers="hover"
                placement="left"
                *appRequirePermission="'followUps'"
                [class.icon-btn-sm]="!coreUtilsService.tabletMode()"
                [class.icon-btn-lg]="coreUtilsService.tabletMode()"
                (click)="addFollowUp(sample)"
              >
                <i
                  class="fa-kit fa-light-square-exclamation-circle-plus fa-fw"
                ></i>
              </button>
              <button
                class="icon-btn mb-1"
                ngbTooltip="Edit sample"
                triggers="hover"
                placement="left"
                *appRequirePermission="'sample.edit'"
                type="submit"
                [class.icon-btn-sm]="!coreUtilsService.tabletMode()"
                [class.icon-btn-lg]="coreUtilsService.tabletMode()"
                (click)="editSample(sample.id, sample.serviceData.id)"
              >
                <i class="fa-light fa-pen fa-fw"></i>
              </button>
            </div>
          </div>
          <hr class="mt-0" />
          <div class="row">
            <div class="col-12 col-lg-6 row align-items-center mb-2">
              <label class="label col-12 col-md-4 mb-0 text-lg-end">{{
                'sample.details.kit' | translate
              }}</label>
              <div class="col-12 col-md-8">
                {{ sample?.kitId }}
              </div>
            </div>
            <div class="col-12 col-lg-6 row align-items-center mb-2">
              <label class="label col-12 col-md-4 mb-0 text-lg-end">{{
                'sample.details.product' | translate
              }}</label>
              <div class="col-12 col-md-8">
                {{ sample.product?.internalName }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-lg-6 row align-items-center mb-2">
              <label class="label col-12 col-md-4 mb-0 text-lg-end">{{
                'sample.details.partner' | translate
              }}</label>
              <div class="col-12 col-md-8">
                {{ sample.partner?.name }}
              </div>
            </div>
            <div class="col-12 col-lg-6 row align-items-center mb-2">
              <label class="label col-12 col-md-4 mb-0 text-lg-end">{{
                'sample.details.doctor' | translate
              }}</label>

              <div class="col-12 col-md-8">
                {{ sample.doctor?.name }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-lg-6 row align-items-center mb-2">
              <label class="label col-12 col-md-4 mb-0 text-lg-end">{{
                'sample.details.dateOfVenipuncture' | translate
              }}</label>
              <div class="col-12 col-md-8">
                {{ sample.dateOfVenipuncture | date: 'short' }}
              </div>
            </div>
            @if (fieldSet.includes(SampleFields.GestationAge)) {
              <div
                *appRequirePermission="'medicalInformation'"
                class="col-12 col-lg-6 row align-items-center mb-2"
              >
                <label class="label col-12 col-md-4 mb-0 text-lg-end">{{
                  'sample.details.gestationAge' | translate
                }}</label>
                <div class="col-12 col-md-8">
                  {{
                    getPropertyFromServiceInformation(
                      sample.serviceInformation,
                      'gestationAge.week'
                    )
                  }}W
                  {{
                    getPropertyFromServiceInformation(
                      sample.serviceInformation,
                      'gestationAge.day'
                    )
                  }}D
                </div>
              </div>
            }
          </div>
          <div class="row">
            <div class="col-12 col-lg-6 row align-items-center mb-2">
              <label class="label col-12 col-md-4 mb-0 text-lg-end">{{
                'sample.details.status' | translate
              }}</label>

              <div class="col-12 col-md-8">
                {{ sample.status }}
              </div>
            </div>
            <div class="col-12 col-lg-6 row align-items-center mb-2">
              <label class="label col-12 col-md-4 mb-0 text-lg-end">{{
                'sample.details.lastStatusChange' | translate
              }}</label>

              <div class="col-12 col-md-8">
                {{ sample.statusTimestamp | date }}
              </div>
            </div>
          </div>
          <div class="row">
            <div
              *appRequirePermission="'laboratory.access'"
              class="col-12 col-lg-6 row align-items-center mb-2"
            >
              <label class="label col-12 col-md-4 mb-0 text-lg-end">{{
                'sample.details.laboratory' | translate
              }}</label>
              <div class="col-12 col-md-8">
                {{ sample.kit.laboratory }}
              </div>
            </div>
            @if (runs$ | async; as runs) {
              <div class="col-12 col-lg-6 row align-items-center mb-2">
                <label class="label col-12 col-md-4 mb-0 text-lg-end">{{
                  'sample.details.runs' | translate
                }}</label>

                <div class="col-12 col-md-8">
                  {{ runs }}
                </div>
              </div>
            }
          </div>
          <ng-container *appRequirePermission="'serviceData.details'">
            <div class="d-flex justify-content-between align-items-end">
              <p class="caption mb-1">
                {{ 'sample.details.serviceInformation' | translate }}
              </p>
            </div>
            <hr class="mt-0" />
            <div class="row">
              <div class="col-12 row align-items-center mb-2">
                <label
                  class="label col-12 col-lg-2 mb-0 text-lg-end"
                  triggers="click:blur"
                  [ngbTooltip]="
                    'sample.details.tooltips.serviceDataDetails' | translate
                  "
                  >{{ 'sample.details.serviceData' | translate }}</label
                >
                <div class="col-12 col-lg-10">
                  <a
                    class="cursor-pointer text-primary"
                    triggers="hover"
                    [ngbTooltip]="
                      'sample.details.tooltips.serviceDataDetails' | translate
                    "
                    (click)="openServiceDataDetails(sample.serviceData.id)"
                  >
                    {{ sample.serviceData.referenceKey }}
                  </a>
                </div>
              </div>
            </div>
          </ng-container>
          <div class="row">
            @if (
              sample?.previousSampleId && previousSample$ | async;
              as previousSample
            ) {
              <div class="col-12 col-lg-6 row align-items-center mb-2">
                <label class="label col-12 col-md-4 mb-0 text-lg-end"
                  >{{ 'sample.details.previousSample' | translate }}:</label
                >
                <div class="col-12 col-md-8">
                  <a
                    class="cursor-pointer text-primary"
                    triggers="hover"
                    [ngbTooltip]="
                      'sample.details.tooltips.openSample' | translate
                    "
                    (click)="openSample(sample.previousSampleId)"
                  >
                    {{ previousSample.kitId }}
                  </a>
                </div>
              </div>
            }
            @if (sample?.nextSampleId && nextSample$ | async; as nextSample) {
              <div class="col-12 col-lg-6 row align-items-center mb-2">
                <label class="label col-12 col-md-4 mb-0 text-lg-end"
                  >{{ 'sample.details.nextSample' | translate }}:</label
                >
                <div class="col-12 col-md-8">
                  <a
                    class="cursor-pointer text-primary"
                    triggers="hover"
                    [ngbTooltip]="
                      'sample.details.tooltips.openSample' | translate
                    "
                    (click)="openSample(sample.nextSampleId)"
                  >
                    {{ nextSample.kitId }}
                  </a>
                </div>
              </div>
            }
          </div>

          <ng-container *appRequirePermission="'waybillInformation'">
            <div class="d-flex justify-content-between align-items-end">
              <p class="caption mb-1">
                {{ 'sample.details.waybillInformation' | translate }}
              </p>
            </div>
            <hr class="mt-0" />
            <div class="row">
              <div class="col-12 col-lg-6 row mb-2">
                <label class="label col-12 col-md-4 mb-0 text-lg-end">{{
                  'sample.details.waybill' | translate
                }}</label>
                <div class="col-12 col-md-8">
                  <u
                    class="cursor-pointer fw-bold"
                    (click)="redirectToDhl(sample.shippingInformation.waybill)"
                  >
                    {{ sample?.shippingInformation?.waybill }}
                  </u>
                </div>
              </div>
              @if (sample.shippingInformation.address; as address) {
                <div class="col-12 col-lg-6 row mb-2">
                  <label class="label col-12 col-md-4 mb-0 text-lg-end">{{
                    'sample.details.senderInformation' | translate
                  }}</label>
                  <div class="col-12 col-md-8">
                    {{ address.fullName }}<br />
                    {{ address.companyName }}<br />
                    {{ address.street }}<br />
                    {{ address.postCode }} {{ address.city }}<br />
                    {{ address.contactNumber }}
                  </div>
                </div>
              }
            </div>
          </ng-container>
          <ng-container *appRequirePermission="'sample.details.sampleNotes'">
            <div class="d-flex justify-content-between align-items-end">
              <p class="caption mb-1">
                {{ 'sample.details.notesTitle' | translate }}
              </p>
            </div>
            <hr class="mt-0" />
            <div class="row">
              <div class="col-12 row align-items-center mb-2">
                <label class="label col-12 col-md-2 mb-0 text-lg-end">{{
                  'sample.details.notes' | translate
                }}</label>
                <div class="col-12 col-md-8">
                  {{ sample.notes || '—' }}
                </div>
              </div>
            </div>
          </ng-container>
        </div>

        @if (sample.shippingInformation.documentId) {
          <div
            *appRequirePermission="'waybillInformation'"
            class="col-12 col-md-6"
          >
            <div class="d-flex justify-content-between align-items-end">
              <p class="caption mb-1">
                {{ 'sample.details.documentPreview' | translate }}
              </p>
            </div>
            <app-document-preview [uri]="onShowPdfSubject$ | async" />
          </div>
        }
      </div>
      @if (sample.shippingInformation.documentId) {
        <div *appRequirePermission="'waybillInformation'" class="form-group">
          <div class="d-flex justify-content-between align-items-end">
            <p class="caption mb-1">
              {{ 'sample.details.waybillDocument' | translate }}
            </p>
          </div>
          <hr class="mt-0" />
          <app-sample-details-dhl-waybill
            [sample]="sample"
            (showPDF)="onShowPdfSubject$.next($event)"
          />
        </div>
      }

      <div class="d-flex justify-content-between align-items-end">
        <p class="caption mb-1">
          {{ 'sample.details.titlePii' | translate }}
        </p>
      </div>
      <hr class="mt-0" />
      <app-data-table
        [configuration]="piisDataTableConfiguration"
      ></app-data-table>
    } @else {
      <div class="py-4 loading"></div>
    }
  </div>
  <div class="modal-footer">
    <button
      ngbAutoFocus
      type="button"
      class="btn btn-clear"
      (click)="dialogRef.close()"
    >
      {{ 'common.buttons.btnClose' | translate }}
    </button>
  </div>
</div>
